export default __webpack_public_path__ + "static/media/part-four-prog-img.1081b596.svg";